<template>
  <div>
    <header-component></header-component>
    <search-view-component
        class="mb-5"
        @onChange="onSearchChange($event)"
        :hideMapButton="true"
    ></search-view-component>



    <section  class="all-categories bg-fadeblue">
      <div class="page-container py-5">
        <div class="row g-0 align-items-center mb-5">
          <div class="col-12 col-sm-7 mb-5 mb-sm-0">
            <h4 class="heading__h4 bold">All Categories</h4>
          </div>
          <div class="col-12 col-sm-5">
            <div class="row g-0 align-items-center">
              <div class="col-12 col-sm-5 pe-4 text-start text-sm-end">Sort by:</div>
                <div class="col-12 col-sm-7">
                    <select
                        @change="onSortChange($event)"
                        class="form-select fs-3 shadow border-0 p-3 rounded-10"
                        aria-label="Default select example"
                        v-model="selectedSortValue"
                    >
                        <option
                            v-for="sortBy in sortArray"
                            v-bind:key="sortBy.Id"
                            v-bind:value="sortBy.Id"
                        >
                            {{ sortBy.Name }}
                        </option>
                    </select>
                </div>
            </div>
          </div>
        </div>
        <div class="row g-0">
          <div class="col-12 col-md-3 pe-0 pe-md-5 mb-5 mb-md-0">
            <div class="category-list bg-white shadow">
              <ul>
                <li v-for="(category, index) in this.categories" :key="index">
                  <a href="javascript:;" @click="loadOffersBySelectedCategory(index)" :class="currentSelectedCategory == index ? 'highlight' : 'normal'" >{{category}}</a>
                </li>
              </ul>
            </div>
          </div>
            <div class="col-12 col-md-9">
                <div class="category-details bg-white shadow">
                    <h3 class="fs-2 bold px-4 mx-2 mb-5 lh-sm">All Stores</h3>
                    <div class="row g-0 px-4 mx-2 mb-5">
                        <div class="col-1">
                        <a href="javascript:;"  @click="loadOffersByStaringLetter('ALL')" :class="currentStartingLetter == 'ALL' ? 'fs-6 highlight' : ' fs-6 normal'">All</a>
                        </div>
                        <div class="col-10" style="word-wrap: break-word">
                            <a href="javascript:;"  :key="letter_index"  @click="loadOffersByStaringLetter(letter_item)"  v-for="(letter_item, letter_index) in ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']"  :class="currentStartingLetter == letter_item ? 'fs-6 px-3 highlight' : ' fs-6 px-3 normal'" >{{letter_item}}</a>
                        </div>
                        <div v-if="totalNumberOfPages" class="col-1 text-end">
                        <a href="javascript:;" style="font-weight: bold"  class="fs-6"> 0-{{totalNumberOfPages}}</a>
                        </div>
                    </div>
                    <div class="loading">
                        <transition name="fade">
                            <font-awesome-icon  v-show="loading" icon="fa-solid fa-spinner fa-2xl" spin />
                        </transition>
                    </div>
                    <div class="offer-details">
                        <offers-block-component :view="'row_view'" :key="item.OfferId" :offer="item" v-for="(item, index) in this.matchedOffers" ></offers-block-component>
                    </div>
                </div>
          </div>
        </div>
      </div>
    </section>
    <footer-component></footer-component>
  </div>
</template>

<script>
import FooterComponent from './FooterComponent.vue';
import HeaderComponent from "./HeaderComponent.vue";
import OffersBlockComponent from './OffersBlockComponent.vue';
import SearchViewComponent from "./search/SearchViewComponent.vue";
export default {
  name: "AllCategoriesComponent",
  components: { HeaderComponent, SearchViewComponent, OffersBlockComponent, FooterComponent },
    data() {
      return {
          categories: [],
          matchedOffers: [],
          pageNumber: 1,
          showNext: false,
          currentStartingLetter: 'ALL',
          currentSelectedCategory: 'all',
          totalNumberOfPages: null,
          loading:false,
          prevCategorySelectedLetter: this.currentStartingLetter + this.currentSelectedCategory,
          itemsPerPage: 15,

          selectedSortValue: "A-Z",

          sortArray: [{ Id: 'A-Z', Name: 'A-Z' }, { Id: 'Z-A', Name: 'Z-A' }, { Id: 'Expiring', Name: 'Expiring' }],

      }
    },
    methods: {

        loadOffersByStaringLetter(startingLetter) {

            this.resetPageNumber();
            this.currentStartingLetter = startingLetter;
            let payload = {
                PageNumber: this.pageNumber,
                ItemsPerPage: this.itemsPerPage,
            };

            if(this.currentStartingLetter != 'ALL') {
                payload.StartingLetter = this.currentStartingLetter;
            }

            if(this.selectedSortValue) {
                payload.SortBy = this.selectedSortValue;
            }

            if(this.currentSelectedCategory != 'all') {
                payload.Category = _.lowerCase(this.currentSelectedCategory).replace(/ /g,"_");
            }

            this.getOffers(payload);
        },

        onSearchChange(merchantName) {
            // if(merchantName.length) {
                let routeData = this.$router.resolve({
                    name: 'search-results',
                    query: {search_term: merchantName, category: 'all'}
                });
                window.open(routeData.href, '_self');
            // }
        },

        loadOffersBySelectedCategory(category) {

           this.resetPageNumber();
           this.currentSelectedCategory = category;
            let payload = {
                PageNumber: this.pageNumber,
                ItemsPerPage: this.itemsPerPage,
            };

            if(this.currentSelectedCategory != 'all') {
                payload.Category = _.lowerCase(this.currentSelectedCategory).replace(/ /g,"_");
            }

            if(this.selectedSortValue) {
                payload.SortBy = this.selectedSortValue;
            }

            if(this.currentStartingLetter != 'ALL') {
                payload.StartingLetter = this.currentStartingLetter;
            }

            this.getOffers(payload);
        },
        resetPageNumber() {
            this.pageNumber = 1; //reset page number
        },
      getAllCategories() {
          axios.get(this.apiEndPoints.getAllCategories)
              .then((response) => {
                  if(response.data && Object.keys(response.data).length) {
                      this.categories = response.data;
                  }
              })
              .catch((error) => {
                  // console.error(error, 'here');
                  // console.error(error.status,'here')

                  if (error.response.status == 401 || error.response.status == 419) {
                      this.$router.push({name : 'sign_in'});
                  }
              }).finally(()=> {
                  // console.log(this.categories);
          });
      },
        next() {
            this.pageNumber = this.pageNumber + 1;

            let payload = {
                PageNumber: this.pageNumber,
                ItemsPerPage: this.itemsPerPage,
            };

            if(this.currentStartingLetter != 'ALL') {
                payload.StartingLetter = this.currentStartingLetter;
            }

            this.getOffers(payload);
        },
        getOffers(payload) {
            this.loading = true;

            axios.post(this.apiEndPoints.matchedOffers, payload)
                .then((response) => {
                    let offers = response?.data?.Response?.Items?.MatchedOffer;

                    let currentPage = response?.data?.Response?.CurrentPage;
                    let noOfPages = response?.data?.Response?.NumberOfPages;

                    if(noOfPages) {
                        this.totalNumberOfPages = noOfPages;
                    }
                    if (noOfPages > currentPage) {
                        this.showNext = true;
                    } else {
                        this.showNext = false;
                    }



                    let currentCategorySelectedLetter = ( payload.StartingLetter || '')  + ( payload.Category || '');
                    if (offers !== undefined) {

                        if(this.pageNumber > 1 && currentCategorySelectedLetter == this.prevCategorySelectedLetter) {
                            let currentOffers = this.matchedOffers;
                            this.matchedOffers = {...currentOffers, ...offers};
                        } else {
                            this.matchedOffers = {...offers};
                        }
                    }
                })
                .catch((error) => {

                    // console.error(error, 'here');
                    // console.error(error.status,'here')

                    if (error.response.status == 401 || error.response.status == 419) {
                        this.$router.push({name : 'sign_in'});
                    }
                }).finally(() => {
                /**
                 * at the end
                 */
                this.loading = false;
                this.prevCategorySelectedLetter = ( payload.StartingLetter || '')  + ( payload.Category || '');
            });

        },
        getNextOffers() {
            window.onscroll = () => {

                let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight > (document.documentElement.offsetHeight - 1);

                if (bottomOfWindow) {
                    // console.log(document.documentElement.scrollTop+=window.innerHeight);
                    // console.log(document.documentElement.offsetHeight -1);
                    this.pageNumber = this.pageNumber + 1;
                    let payload = {
                        PageNumber: this.pageNumber,
                        ItemsPerPage: this.itemsPerPage,
                    };

                    if( this.currentSelectedCategory != 'all') {
                        payload.Category = _.lowerCase(this.currentSelectedCategory).replace(/ /g,"_");
                    }

                    if(this.currentStartingLetter != 'ALL') {
                        payload.StartingLetter = this.currentStartingLetter;
                    }

                    if(this.selectedSortValue) {
                        payload.SortBy = this.selectedSortValue;
                    }

                    this.getOffers(payload);
                }
            }
        },

        onSortChange(event) {
             this.resetPageNumber();
            // this.currentSelectedCategory = category;
            let payload = {
                PageNumber: this.pageNumber,
                ItemsPerPage: this.itemsPerPage,
            };

            if(this.currentSelectedCategory != 'all') {
                payload.Category = _.lowerCase(this.currentSelectedCategory).replace(/ /g,"_");
            }

            if(this.selectedSortValue) {
                payload.SortBy = this.selectedSortValue;
            }

            if(this.currentStartingLetter != 'ALL') {
                payload.StartingLetter = this.currentStartingLetter;
            }

            this.getOffers(payload);
        },
    },
    mounted() {
        this.getNextOffers();

        this.getAllCategories();

        this.getOffers({
            PageNumber: this.pageNumber,
            ItemsPerPage: this.itemsPerPage,
            SortBy: this.selectedSortValue
        });
    }
};
</script>

<style scoped>
    .highlight {
        font-weight: bold;
        color:blue;
        cursor:pointer;
    }

    .normal {
        cursor:pointer;
    }
     .loading {
         text-align: center;
         position: fixed;
         color: darkgray;
         z-index: 9;
         font-size: 5vw;
         /*background: #5c4084;*/
         /*padding: 8px 18px;*/
         /*border-radius: 5px;*/
         left: calc(50% - 45px);
         top: calc(50% - 18px);
     }

    .fade-enter-active, .fade-leave-active {
        transition: opacity 2s
    }
    .fade-enter, .fade-leave-to {
        opacity: 0
    }

    .offer_tile {

    }

</style>
